import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import './footer.scss'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerSections = [
    {
      title: 'Quick Links',
      links: [
        { label: 'Home', path: '/' },
        // { label: 'Latest Songs', path: '/latest' },
        // { label: 'Trending', path: '/trending' },
        { label: 'Albums', path: '/albums' },
        // { label: 'Artists', path: '/artists' },
      ],
    },
    {
      title: 'Categories',
      links: [
        { label: 'New Releases', path: '/new-releases' },
        { label: 'Old Songs', path: '/old-songs' },
        { label: 'Duets', path: '/duets' },
        { label: 'Solo Songs', path: '/solo-songs' },
        { label: 'Movie Songs', path: '/movie-songs' },
      ],
    },
    {
      title: 'Popular Artists',
      links: [
        { label: 'A.R. Rahman', path: '/artist/ar-rahman' },
        { label: 'Ilaiyaraaja', path: '/artist/ilaiyaraaja' },
        { label: 'Harris Jayaraj', path: '/artist/harris-jayaraj' },
        { label: 'Anirudh', path: '/artist/anirudh' },
        { label: 'Yuvan Shankar Raja', path: '/artist/yuvan-shankar-raja' },
      ],
    },
  ]

  const socialLinks = [
    { label: 'Facebook', icon: '📘', url: 'https://facebook.com/thamizhsongs' },
    { label: 'Twitter', icon: '🐦', url: 'https://twitter.com/thamizhsongs' },
    { label: 'Instagram', icon: '📸', url: 'https://instagram.com/thamizhsongs' },
    { label: 'YouTube', icon: '🎥', url: 'https://youtube.com/thamizhsongs' },
  ]

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <GatsbyImage
                image={getImage('../../images/logo/logo.png')}
                alt="Thamizh Songs Logo"
                className="footer__logo-image"
              />
              <span>Thamizh Songs</span>
            </Link>
            <p className="footer__description">
              Your ultimate destination for accurate and up-to-date lyrics of your favorite Tamil songs.
              Discover the latest and classic Tamil movie song lyrics.
            </p>
          </div>

          <div className="footer__sections">
            {footerSections.map((section) => (
              <div key={section.title} className="footer__section">
                <h3 className="footer__section-title">{section.title}</h3>
                <ul className="footer__section-links">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path} className="footer__section-link">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__social">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={social.label}
              >
                <span className="footer__social-icon">{social.icon}</span>
              </a>
            ))}
          </div>

          <div className="footer__legal">
            <p className="footer__copyright">
              © {currentYear} Thamizh Songs. All rights reserved.
            </p>
            <div className="footer__legal-links">
              <Link to="/privacy-policy" className="footer__legal-link">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="footer__legal-link">
                Terms of Service
              </Link>
              <Link to="/contact" className="footer__legal-link">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 